import ResourceManager from "../../components/ResourceManager/ResourceManager"
import { useOptions } from "../../options/hooks/use-options"
import { StringMap } from "../../types/common"
import { useI18n } from "../../hooks"
import { TodoViewModel } from "../api/todo"
import { useTodoMutations } from "../hooks/use-todo-mutations"

const TodoCustomerWidget = ({ todo, boardId, columnPosition }: TodoCustomerWidgetProps) => {
  const translations = useTranslations()
  const { customerOptions } = useOptions(todo.organisation?.id)
  const { updateCustomers } = useTodoMutations()

  // Full updated customer array
  const onAddCustomers = (ids: string[]) => {
    const customers = [
      ...todo.customers,
      ...customerOptions.filter((c) => ids.includes(c.id)).map((c) => ({ id: c.id, name: c.name })),
    ]
    updateCustomers(todo.id, { customers, boardId, columnPosition })
  }

  const onRemoveCustomer = (customerId: string) => {
    const customers = todo.customers.filter((c) => c.id !== customerId)
    updateCustomers(todo.id, { customers, boardId, columnPosition })
  }

  const sortedCustomerOptions = customerOptions
    .slice()
    .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
  const sortedCustomers = todo.customers
    .slice()
    .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))

  return (
    <ResourceManager
      title={translations.title}
      resourceOptions={sortedCustomerOptions}
      resources={sortedCustomers}
      canAddResource={todo.canUpdate}
      canRemoveResource={todo.canUpdate}
      onAddResources={onAddCustomers}
      onRemoveResource={onRemoveCustomer}
      emptyOptionsMessage={translations.emptyOptionsMessage}
      emptyResourcesMessage={translations.emptyResourcesMessage}
      isMultipleSelection
    />
  )
}

const useTranslations = (defaults = defaultTranslations): Translations => {
  const { translations: t } = useI18n("todo")
  const translations = (t?.customerWidget || {}) as StringMap

  const {
    title = defaults.title,
    emptyOptionsMessage = defaults.emptyOptionsMessage,
    emptyResourcesMessage = defaults.emptyResourcesMessage,
    updateErrorMessage = defaults.updateErrorMessage,
  } = translations

  return {
    title,
    emptyOptionsMessage,
    emptyResourcesMessage,
    updateErrorMessage,
  }
}

const defaultTranslations = {
  title: "Customers",
  emptyOptionsMessage: "No customers available",
  emptyResourcesMessage: "Todo is not connected to any customers",
  updateErrorMessage: "Failed to update customers",
}

type Translations = typeof defaultTranslations

type TodoCustomerWidgetProps = {
  todo: TodoViewModel
  boardId?: string
  columnPosition?: number
}

export default TodoCustomerWidget
